module.exports = __webpack_public_path__ + "img/deposit4.e58fa16d.jpg";